// 体验项目管理
export default [
  {
    path: '/experienceProject',
    // name: 'experienceProject',
    meta: { title: '体验项目管理' },
    component: () => import('../views/experienceProject/index'),
    children: [
      {
        path: '/experienceProject/experienceList',
        // name: 'experienceList',
        meta: { title: '体验项目列表', isMenu: true },
        component: () => import('../views/experienceProject/experienceList'),
      },
      {
        path: '/experienceProject/detail/modify',
        // name: 'modify',
        meta: { title: '修改体验项目' },
        component: () => import('../views/experienceProject/detail/modify'),
      },
      {
        path: '/experienceProject/detail/addProduct',
        // name: 'addProduct',
        meta: { title: '新增体验项目' },
        component: () => import('../views/experienceProject/detail/addProduct'),
      },
      
    ],
  },
]; 
